import { AsyncPipe, KeyValuePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { FileProgressComponent } from '@file-upload/components/file-progress/file-progress.component';
import { FilesStateService } from '@file-upload/services/files-state.service';

@Component({
  selector: 'app-file-download-list',
  templateUrl: './file-download-list.component.html',
  styleUrls: ['./file-download-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe, KeyValuePipe, FileProgressComponent]
})
export class FileDownloadListComponent {
  readonly #filesStateService = inject(FilesStateService);

  files$ = this.#filesStateService.downloadingFiles$;
}
